export default "__VITE_ASSET__BZl6$3Ng__"